export default __webpack_public_path__ + "static/media/pharmacy.a913aade.svg";